import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { UserAdminReport } from '@/module/AnnualReport/perRole/UserAdminReport';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyFacultySelect } from '@feature/utils';
import { useFacultyAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';
import { ValidationStatus } from '@feature/validation';

export interface FacultyAdminReportProps {
  year: number;
  validationStatus: ValidationStatus | null;
  filterAfterAffiliation: boolean;
}

export function FacultyAdminReport({ year, validationStatus, filterAfterAffiliation }: FacultyAdminReportProps) {
  const { userId, selectProps } = useFacultyAdminHierarchy();
  const { t } = useTranslation();

  return (
    <Stack>
      <HierarchyFacultySelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromFaculties')} />}
      {userId != null && (
        <UserAdminReport
          userId={userId}
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
    </Stack>
  );
}
